module.exports = __webpack_public_path__ + "static/media/part4.f472a721.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/part4.jpg
// module id = 806
// module chunks = 1